import { type FC } from "react";
import { SettingsItemTemplate, type Item } from "@/pages/settings/__components__/SettingsItemTemplate";
import { pagesPath } from "@/pathpida/generated/$path";
import { accountSettingsTestId } from "./const";
import { isNonNullable } from "@/modules/utils/predicate";

interface AccountSettingsProps {
  readonly familyCustomerId: number | null | undefined;
  readonly isReceiver: boolean | null | undefined;
  readonly isMfaActive: boolean | null | undefined;
}

export const AccountSettings: FC<AccountSettingsProps> = ({ familyCustomerId, isReceiver, isMfaActive }) => {
  const menuItems: Item[] = [
    { icon: "envelope", text: "メールアドレスの変更", href: pagesPath.settings.account.change.email.$url() },
    { icon: "key", text: "パスワードの変更", href: pagesPath.settings.account.change.password.$url() },
    {
      icon: "lock",
      text: "二段階認証",
      href: pagesPath.settings.account.mfa.$url(),
      tagItem: isMfaActive ? { text: "オン", colorScheme: "theme.green" } : { text: "オフ", colorScheme: "darkgray" },
    },
  ];

  if (isReceiver) {
    menuItems.push({
      icon: "ticket",
      text: "お手持ちのおもちゃ買取りクーポン",
      href: pagesPath.settings.account.toy_coupon.$url(),
    });
  }

  return (
    <SettingsItemTemplate
      data-testid={accountSettingsTestId}
      title={isNonNullable(familyCustomerId) ? `アカウント (C${familyCustomerId})` : "アカウント"}
      items={menuItems}
    />
  );
};
